import { render, staticRenderFns } from "./client-switcher.vue?vue&type=template&id=c4f2e058&scoped=true&"
import script from "./client-switcher.vue?vue&type=script&lang=js&"
export * from "./client-switcher.vue?vue&type=script&lang=js&"
import style0 from "./client-switcher.vue?vue&type=style&index=0&id=c4f2e058&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2e058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4f2e058')) {
      api.createRecord('c4f2e058', component.options)
    } else {
      api.reload('c4f2e058', component.options)
    }
    module.hot.accept("./client-switcher.vue?vue&type=template&id=c4f2e058&scoped=true&", function () {
      api.rerender('c4f2e058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/client-switcher.vue"
export default component.exports